module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_0.22363103.png";